import * as React from 'react';

import { PropertyAnnouncementType } from './types';
import OfferMessageBox from './OfferMessageBox';

interface OfferMessageListProps {
  propertyAnnouncements: PropertyAnnouncementType[];
  onPropertyAnnouncementSelected: (id: string) => void;
  selectedPropertyAnnouncement: PropertyAnnouncementType;
}

interface OfferMessageListState {
  searchValue: string;
  filteredPropertyAnnouncements: PropertyAnnouncementType[];
}

class OfferMessageList extends React.Component<
  OfferMessageListProps,
  OfferMessageListState
> {
  constructor(props: OfferMessageListProps) {
    super(props);

    this.state = {
      searchValue: '',
      filteredPropertyAnnouncements: [...this.props.propertyAnnouncements],
    };
  }

  searchPropertyAnnouncements = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = e.target.value;
    const searchedPropertyAnnouncements =
      this.props.propertyAnnouncements.filter(propertyAnnouncement => {
        if (
          propertyAnnouncement.subject.toLowerCase().includes(searchText) ||
          propertyAnnouncement.body.toLowerCase().includes(searchText)
        ) {
          return true;
        }

        return false;
      });
    this.setState({
      searchValue: searchText,
      filteredPropertyAnnouncements: searchedPropertyAnnouncements,
    });
  };

  render() {
    const { onPropertyAnnouncementSelected, selectedPropertyAnnouncement } =
      this.props;
    const { searchValue, filteredPropertyAnnouncements } = this.state;

    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <div className="offer-message-search-box">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchValue}
                onChange={this.searchPropertyAnnouncements}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {filteredPropertyAnnouncements.map(propertyAnnouncement => (
              <OfferMessageBox
                key={propertyAnnouncement.id}
                propertyAnnouncement={propertyAnnouncement}
                onClick={onPropertyAnnouncementSelected}
                isActive={
                  selectedPropertyAnnouncement &&
                  selectedPropertyAnnouncement.id === propertyAnnouncement.id
                }
              />
            ))}
          </div>
        </div>
      </>
    );
  }
}

export default OfferMessageList;
